// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu-action[data-v-50752f0c]{height:56px}.action-icon[data-v-50752f0c],.menu-action[data-v-50752f0c]{display:flex;align-items:center;justify-content:center}.action-icon[data-v-50752f0c]{padding:4px 16px;cursor:pointer}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
